var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChartNormal',{attrs:{"size":"12","offset":"0","title":"Under Warranty","chart":"column","chartType":"war","isCity":false,"withDate":true,"withFinancial":false}})}
var staticRenderFns = []

export { render, staticRenderFns }